exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.map-toolbar {\n  pointer-events: none;\n}\ndiv.map-toolbar button {\n  pointer-events: all;\n}\n.map-toolbar-dropdown {\n  min-width: 0px;\n}\n.mode-active .btn {\n  opacity: 0.65 !important;\n}\n.right-border {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.custom-margin {\n  margin-right: 0.15rem;\n}\n", ""]);

// exports
